import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { inject, injectable } from 'inversify';
import { format } from '@/@core/utils/string';
import { Symbols } from '../../symbols';
import { buildFormDate } from '@/@core/utils/form';
import qs from 'qs';
let ProductApi = class ProductApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        //  修改客户端
        this.patchClients = (id, params) => {
            const url = `${this.urls.getClients}/${id}`;
            delete params.id;
            return this.http.patch({
                url,
                data: qs.stringify(params),
                headers: {
                    'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
                },
                method: 'PATCH',
            });
        };
    }
    // 获取资源详情
    getResource(resource_id) {
        const url = format(this.urls.getResource, { resource_id });
        return this.http.get({
            url,
        });
    }
    // 删除资源详情
    deleteResource(resource_ids) {
        const url = this.urls.deleteResource;
        return this.http.delete({
            url,
            data: {
                resource_ids,
            },
        });
    }
    // 修改 / 新增资源
    postResource(params) {
        const url = this.urls.postResource;
        return this.http.post({
            url,
            params,
        });
    }
    // 获取资源国际化
    getResourceLan(resource_id) {
        const url = format(this.urls.getResourceLan, { resource_id });
        return this.http.get({
            url,
        });
    }
    // 修改资源国际化
    postResourceLan(resource_id, params) {
        const url = format(this.urls.getResourceLan, { resource_id });
        return this.http.post({
            url,
            params,
        });
    }
    // 获取 资源 API 数据
    getResourceApi(resource_id) {
        const url = format(this.urls.getResourceApi, { resource_id });
        return this.http.get({
            url,
        });
    }
    // 删除 资源 API
    deleteResourceApi(resource_id) {
        const url = format(this.urls.getResourceApi, { resource_id });
        return this.http.delete({
            url,
        });
    }
    // 修改 资源 API
    postResourceApi(params) {
        const url = this.urls.postResourceApi;
        return this.http.post({
            url,
            params,
        });
    }
    // 获取 产品 - 角色
    getProductRoles(product_id) {
        const url = format(this.urls.getProductRoles, { product_id });
        return this.http.get({
            url,
        });
    }
    // 获取 产品 - 所有角色 - 资源
    getProductResource(product_id) {
        const url = format(this.urls.getProductResource, { product_id });
        return this.http.get({
            url,
        });
    }
    // 获取 产品 - 所有角色 - 模块下的 - 资源
    getProductResourceByModule(product_id, module_type) {
        const url = format(this.urls.getProductResourceByModule, { product_id, module_type });
        return this.http.get({
            url,
        });
    }
    // 获取 产品 - 所有角色 - 数据资源
    getProductDataResource(product_id) {
        const url = format(this.urls.getProducDataResource, { product_id });
        return this.http.get({
            url,
        });
    }
    // 产品相关
    getProducts() {
        const url = this.urls.getProducts;
        return this.http.get({
            url,
            uuid: url,
        });
    }
    postProducts(params) {
        const url = this.urls.getProducts;
        return this.http.postForm({
            url,
            data: buildFormDate(params),
        });
    }
    deleteProducts(id) {
        const url = `${this.urls.getProducts}/${id}`;
        return this.http.delete({
            url,
        });
    }
    // 客户端相关
    getClientsList(params) {
        const url = this.urls.getClients;
        return this.http.get({ url, params: params });
    }
    // 客户端详情
    getClientDetail(id) {
        const url = `${this.urls.getClients}/${id}`;
        return this.http.get({ url });
    }
    // 新增修改 客户端
    postClients(params) {
        const url = this.urls.getClients;
        return this.http.post({
            url,
            params,
        });
    }
    // 删除客户端
    deleteClients(id) {
        const url = `${this.urls.getClients}/${id}`;
        return this.http.delete({
            url,
        });
    }
    // 获取客户端权限
    getClientRole(id) {
        const url = `${this.urls.getClientRoles}/client/${id}`;
        return this.http.get({ url });
    }
    postClientRole(params) {
        const url = this.urls.getClientRoles;
        return this.http.post({ url, params });
    }
    deleteClientRole(clientId, productRoleId) {
        const url = `${this.urls.getClientRoles}/client/${clientId}/role/${productRoleId}`;
        return this.http.delete({ url });
    }
    getWithUnlockedRoles(productIds) {
        const url = this.urls.getWithUnlockedRoles;
        return this.http.get({
            url,
            params: {
                product_ids: _.join(productIds, ','),
            },
        });
    }
    getFeatureCapacityRoles(productIds) {
        const url = this.urls.getFeatureCapacityRoles;
        return this.http.get({
            url,
            params: {
                product_ids: _.join(productIds, ','),
            },
        });
    }
    getRoles(productIds) {
        const queryString = encodeURIComponent('productIds[]') + '=' + _.join(productIds, ',');
        const url = this.urls.getRoles + '?' + queryString;
        return this.http.get({
            url,
        });
    }
    getProductAllRoles(product_id) {
        const url = format(this.urls.getProductAllRoles, {
            product_id,
        });
        return this.http.get({
            url,
        });
    }
    getAllRoles() {
        return this.http.get({ url: this.urls.getRoles });
    }
    // #region 产品角色限制
    /* 通过产品 => 产品角色: */
    getProductEnableRoleList(product_id) {
        const url = format(this.urls.productEnableRoleList, { product_id });
        return this.http.get({ url });
    }
    /* 获取资源: */
    getProductResouce() {
        return this.http.get({ url: this.urls.productResouce });
    }
    /* 获取资源对应的限制信息: */
    getResourcesRoleLimitation(id) {
        const url = format(this.urls.resourcesRoleLimitation, { id });
        return this.http.get({ url });
    }
    /* 编辑限制信息: */
    postProductRolesLimitation(params) {
        return this.http.post({
            url: this.urls.productRolesLimitation,
            params,
        });
    }
    getResourcesProductResources(product_id) {
        const url = format(this.urls.getResourcesProductResources, { product_id });
        return this.http.get({
            url,
        });
    }
    getResourcesRoleResources(role_id) {
        const url = format(this.urls.getResourcesRoleResources, { role_id });
        return this.http.get({
            url,
        });
    }
};
ProductApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.ProductApiUrls)),
    __metadata("design:paramtypes", [Object, Object])
], ProductApi);
export { ProductApi };
